import { computed } from 'vue';

import { useFeedsStore } from '@/stores';

import { isPartnerMappingEligibleFeedType } from '../partnerMappingEligibility';

/**
 * Decides whether the Partner Mapping tab should be exposed for a feed. The tab
 * is shown for any Salesforce or Snowflake data source — the source types whose
 * partner mappings feed a consumer today (the SFDC overlap push, the Snowflake
 * share, and recommended partners). Derived FE-side from the feed's integration
 * type, no dedicated backend signal.
 */
export function usePartnerMappingEligibility(feedId: () => number | undefined) {
  const feedsStore = useFeedsStore();

  const isEligibleForPartnerMapping = computed(() => {
    const id = feedId();
    if (id == null) return false;
    return isPartnerMappingEligibleFeedType(
      feedsStore.getFeedById(id)?.integration?.type,
    );
  });

  return { isEligibleForPartnerMapping };
}
